import {
  HotelIcon,
  LocationIcon,
  StarIcon,
  ChainIcon,
  LuggageIcon,
  CruiseIcon,
  BusIcon,
} from '@assets/icons';
import { WebUrlType } from '@api/v3';

export const getLocationIcon = (type: string) => {
  switch (type) {
    case WebUrlType.HOTEL:
      return HotelIcon;

    case WebUrlType.HOTEL_REGION:
    case WebUrlType.PACKAGE_REGION:
      return LocationIcon;

    case WebUrlType.HOTEL_CITY:
    case WebUrlType.PACKAGE_CITY:
      return LocationIcon;

    case WebUrlType.HOTEL_CHAIN:
      return ChainIcon;

    case WebUrlType.HOTEL_THEME:
    case WebUrlType.PACKAGE_THEME:
    case WebUrlType.TOUR_SPECIAL_PERIOD:
      return StarIcon;

    case WebUrlType.CRUISE:
      return CruiseIcon;

    case WebUrlType.CRUISE_THEME:
      return LuggageIcon;

    case WebUrlType.TOUR_COUNTRY:
    case WebUrlType.TOUR_CONTINENT:
      return LocationIcon;

    case WebUrlType.CRUISE_REGION:
      return LocationIcon;

    case WebUrlType.TOUR_THEME:
    case WebUrlType.TAG:
      return LuggageIcon;

    case WebUrlType.TOUR_REGION:
      return LocationIcon;

    case WebUrlType.TOUR:
      return BusIcon;

    case WebUrlType.TOUR_CITY:
      return LocationIcon;

    default:
      return HotelIcon;
  }
};
